// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"412":"e536e7ab","523":"e536e7ab"}[chunkId] + ".chunk.css";
};